module.exports = __webpack_public_path__ + "static/media/Orange.7561f466.png";